
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M14.633 21.854l-3-3a.498.498 0 01.36-.86h2v-7.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v7.5h2a.499.499 0 01.36.85l-3 3a.51.51 0 01-.72.01zm-4.64-8.36v-7.5h2a.5.5 0 00.36-.85l-3-3a.51.51 0 00-.71 0l-3 3a.5.5 0 00.35.85h2v7.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5z"}})])
          )
        }
      }
    